var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 6C22 3.79086 23.7909 2 26 2C28.2091 2 30 3.79086 30 6V26C30 28.2092 28.2091 30 26 30C23.7909 30 22 28.2092 22 26V6ZM26 28C27.1046 28 28 27.1046 28 26V6C28 4.89544 27.1046 4 26 4C24.8954 4 24 4.89544 24 6V26C24 27.1046 24.8954 28 26 28ZM2 18C2 15.7909 3.79086 14 6 14C8.20914 14 10 15.7909 10 18L10 26C10 28.2092 8.20914 30 6 30C3.79086 30 2 28.2092 2 26L2 18ZM6 28C7.10456 28 8 27.1046 8 26L8 18C8 16.8954 7.10456 16 6 16C4.89544 16 4 16.8954 4 18L4 26C4 27.1046 4.89544 28 6 28ZM16 10C13.7908 10 12 11.7909 12 14L12 26C12 28.2092 13.7908 30 16 30C18.2092 30 20 28.2092 20 26V14C20 11.7909 18.2092 10 16 10ZM16 12C17.1046 12 18 12.8954 18 14V26C18 27.1046 17.1046 28 16 28C14.8954 28 14 27.1046 14 26L14 14C14 12.8954 14.8954 12 16 12Z",
    fill: "#131542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopment);
export default __webpack_public_path__ + "static/media/Development.b586dc88dc4ea10d5e4f6fc11850fa63.svg";
export { ForwardRef as ReactComponent };